import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import About from '../components/About';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Approach from '../components/Approach';
import Clients from '../components/Clients';
import WhyUs from '../components/WhyUs';
import { CTABanner } from '../components/PageHero';

export default function HomePage() {
  return (
    <>
      <SEO
        title={null}
        description="Salihi Consulting Services partners with governments, enterprises, NGOs and development institutions to deliver financial, compliance, technology and advisory transformations across Somalia and East Africa."
        path="/"
        keywords="Salihi Consulting, consulting firm Somalia, business advisory, accounting, tax compliance, ERP, capital raising, NGO advisory, Mogadishu"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Salihi Consulting Services — Premium Consulting Firm',
          description:
            'Premium multidisciplinary consulting firm serving governments, enterprises, NGOs and development partners.',
          url: 'https://salihiconsulting.com/',
          isPartOf: { '@id': 'https://salihiconsulting.com/#website' },
          about: { '@id': 'https://salihiconsulting.com/#organization' },
        }}
      />
      <Hero />
      <Stats />
      <About />
      <Services showAll={false} />
      <Industries />
      <Approach />
      <Clients />
      <WhyUs />
      <CTABanner />
    </>
  );
}
